<div class="jumbotron">
  <div class="container">
    <br>
      <div class="row">
        <div class="col-sm-12 table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr class="header-color" class="table-secondary">
                <th>#</th>
                <th>Patient</th>
                <th>Doctor</th>
                <th>Service</th>
                <th>Date</th>
                <th>Period</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @if (items.length == 0) {
                <tr>
                  <td colspan="7">No data found</td>
                </tr>
              }
              @for (item of items | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; track item; let i = $index) {
                <tr
                  [class]="item?.Package_Patient?.no_sessions_took==item?.Package_Patient?.no_sessions? 'green_bold' : ''">
                  <td>{{ ((page-1) * pageSize) + (i+1) }}</td>
                  <td align="left" style="cursor: pointer; color: blue;" (click)="goToDetails(item)">
                    {{item?.patient.first_name}} {{item?.patient.last_name}}
                  </td>
                  <td>
                    {{item?.doctor?.name}}
                  </td>
                  <td>{{item?.appointment?.service_name}}</td>
                  <td>{{item?.appointment?.date | date:'dd/MM/yyyy'}}</td>
                  <td>{{item?.appointment.period}}m</td>
                  <td><span class="badge bg-primary mx-1">{{item?.appointment?.status}}</span></td>
                  <td>
                    <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                      style="direction:ltr">
                      <button type="button" class="btn btn-secondary"
                        (click)="close(item?.appointment?.id)"><svg xmlns="http://www.w3.org/2000/svg"
                        width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill"
                        viewBox="0 0 16 16">
                        <path
                          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                      </svg>
                    </button>
                    <button type="button" class="btn btn-warning"
                      (click)="cancel(item?.appointment?.id)"><svg xmlns="http://www.w3.org/2000/svg"
                      width="16" height="16" fill="currentColor" class="bi bi-x-octagon-fill"
                      viewBox="0 0 16 16">
                      <path
                        d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <ngb-pagination [collectionSize]="items.length" [(page)]="page" [maxSize]="5" [rotate]="true"
      [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
    </div>
  </div>
</div>
</div>